// -*- Mode: rjsx -*-
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconLoop from '@mui/icons-material/Loop';
import IconSend from '@mui/icons-material/Send';


import { FHMaterialStyles, FancyTextEntry } from '../../../ui';

import { getCacheKey } from '..';

function ResponseTextEntry(props) {
    const cacheKey = getCacheKey(props);
    const classes = FHMaterialStyles();
    const user = useSelector(state => state.hud.user);

    let s = {margin: 16, backgroundColor: "white"};

    function doSend(e) {
        e.preventDefault();
        props.onSend(props.request.key);
    }
    
    let button = (
        <Button
          variant="contained"
          color="primary"
          endIcon={<IconSend />}
          onClick={doSend}>{props.sendButtonTitle}</Button>
    );
    
    if(props.sending)
        button = <Button
                   variant="contained"
                   color="primary"
                   endIcon={<IconLoop />}
                   disabled={true}>Sending</Button>;
    
    return (
        <Grid style={s}>
          
          <Grid item className={classes.fancyTextInputHeader}>
            <Typography color="textSecondary">Hello,</Typography>
          </Grid>
          
          <Grid item>
            <FancyTextEntry
              showing={props.showing}
              footer={<Typography color="textSecondary">{"Regards, " +  user.name}</Typography> }
              onChange={props.onChange}
              cacheKey={cacheKey} />
          </Grid>
          
          <Grid container
                justifyContent="flex-end"
                style={{ marginTop: 16, padding: 16 }}>
            { button } 
          </Grid>          
        </Grid>
    );
        
        
}

export default ResponseTextEntry;

         
